/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2024)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { FC, MouseEvent } from "react"

import { BaseButton, BaseButtonKind } from "@streamlit/lib"

import { DeployButtonContainer } from "./styled-components"

interface IDeployButtonProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => any
}

const DeployButton: FC<IDeployButtonProps> = ({ onClick }) => {
  return (
    <div className="stAppDeployButton" data-testid="stAppDeployButton">
      <BaseButton kind={BaseButtonKind.HEADER_BUTTON} onClick={onClick}>
        <DeployButtonContainer>
          <span>Deploy</span>
        </DeployButtonContainer>
      </BaseButton>
    </div>
  )
}

export default DeployButton
